(function($) {
    $(() => {
        $('.own-dropdown-toggle').on('click', function() {
            $(this)
                .parent()
                .find('.own-dropdown-list')
                .toggleClass('show');

            $(this).toggleClass('show');
        });

        $('.own-dropdown-item').on('click', function() {
            $(this).parent().removeClass('show');
            $(this).parent().parent().find('.own-dropdown-toggle__text').html($(this).html());
            $(this).parent().parent().find('.own-dropdown-toggle').removeClass('show');
        });
    });
})(jQuery);